/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const mock = [
   {   
        description:
        'Parent Orientation Day',
        href : '/Parent-Orientation-Day2026'
    }, 
   {   
        description:
        'Investiture Ceremony',
        href : '/investiture-ceremony-2026'
    
    },{   
        description:
        'Teacher Orientation',
        href : '/teacher-orientation-2026'
    
    },
    {   
    description:
      'International Yoga Day ',
    href : '/international-yoga-day-2026'
 
  },
   {   
    description:
       'SOCIAL AND EMOTIONAL LEARNING',
    href : '/social-and-emotional-learning-2026'
  },
   {   
    description:
       'PROMOTING MENTAL HEALTH AND WELL BEING',
    href : '/cbsc-workshop-2026'
  },
  {   
    description:
       'ART AND CRAFT WORKSHOP',
    href : '/art-craft-workshop-2026'
  },
   {   
    description:
      'Goonj Event 2026-27 ',
    href : '/goonj-2026'
 
  },
  {   
    description:
      'ELEVATE-INTER-SCHOOL SPORTS MEET ',
    href : '/elevate-2026'
 
  },
   {   
    description:
      'Independence Day Juniors (Pre Primary- Class 4) ',
    href : '/independence-day-juniors-2026'
 
  },
   {   
    description:
      'Independence Day Programme Classes 5-12 ',
    href : '/independence-day-2026'
 
  },
   {   
    description:
      'Onam and Eid Milad Celebrations ',
    href : '/onam-and-eid-celebration-2026'
 
  },
   {   
    description:
      'Science Exhibition ',
    href : '/science-exhibition-2026'
 
  },
   {   
    description:
      ' Teachers Day Celebration 1 to 8 ',
    href : '/teachers-day-1-to-8-2026'
 
  },
 {   
    description:
      ' Teachers Day Celebration 9 to 12 ',
    href : '/teachers-day-9-to-12-2026'
 
  },
 {   
    description:
      ' Hindi Diwas 2026 ',
    href : '/hindi-diwas-2026'
 
  },

];

const Sidebar2026 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        School Programs 2026-27
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href = {item.href}>
                <Typography component={'P'}>
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Sidebar2026;